<template>
    <div class="form__item form__input--numbers">
        <slot></slot>
        <i class="mdi mdi-menu-up icon icon-up" @click="up"></i>
        <i class="mdi mdi-menu-down icon icon-down" @click="down"></i>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class InputNumbers extends Vue {
    name = 'input-numbers';

    up() {
        this.$emit('up');
    }

    down() {
        this.$emit('down');
    }
}

Vue.component('input-numbers', InputNumbers);
</script>
